import { Route, Routes } from "react-router-dom";

import Signin from "./Signin.jsx";
import SigninSilent from "./SigninSilent";
import Logout from "./Logout.jsx";
import DashboardOverview from "./DashboardOverview";

import NotFound404Page from "./NotFound404Page";

import { AuthenticationInfoType } from "../utility/types";
import OrganizationInfo from "./OrganizationInfo";
import UserInfo from "./UserInfo";
import PublishProject from "./PublishProject/PublishProject";
import Deployments from "./Deployments";
import Projects from "./Projects/Projects";

type IProps = {
  auth: AuthenticationInfoType;
};

const Routing = ({ auth }: IProps) => {
  const isAuthenticated = !!auth;
  return (
    <div id="Routing">
      <Routes>
        <Route path="/" element={<DashboardOverview />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/silent-renew" element={<SigninSilent />} />
        <Route path="/signout" element={<Logout />} />

        <Route path="/organization" element={isAuthenticated ? <OrganizationInfo auth={auth} /> : <Logout />} />
        <Route path="/userinfo" element={isAuthenticated ? <UserInfo auth={auth} /> : <Logout />} />
        <Route path="/publish" element={isAuthenticated ? <PublishProject auth={auth} /> : <Logout />} />
        <Route path="/deployments" element={isAuthenticated ? <Deployments auth={auth} /> : <Logout />} />
        <Route path="/projects/:orgid?" element={isAuthenticated ? <Projects auth={auth} /> : <Logout />} />
        <Route element={<NotFound404Page />} />
      </Routes>
    </div>
  );
};

export default Routing;
